// @ts-check
// Erros não tratados da SPA vão para /rest/client-errors (log estruturado e DSN do Worker, contrato 08).
// Limite por sessão para um erro em laço não inundar o monitoramento; no modo demonstração nada é enviado.
import { isMockEnabled } from '../data/api-client.js';
import { reportClientError } from '../data/operations.js';

const MAXIMUM_REPORTS_PER_PAGE_LOAD = 5;

export function startClientErrorReporter() {
  let reportCount = 0;
  /** @type {Set<string>} */
  const reported = new Set();
  /** @param {unknown} error @param {string} [fallbackMessage] */
  const report = (error, fallbackMessage = 'Unknown error') => {
    if (isMockEnabled() || reportCount >= MAXIMUM_REPORTS_PER_PAGE_LOAD) return;
    const message = error instanceof Error ? error.message : fallbackMessage;
    if (reported.has(message)) return;
    reported.add(message);
    reportCount += 1;
    const stack = error instanceof Error ? error.stack ?? '' : '';
    reportClientError({ message, stack, url: window.location.href }).catch(() => {});
  };
  window.addEventListener('error', (event) => report(event.error, event.message));
  window.addEventListener('unhandledrejection', (event) => {
    // erros da API já viram snackbar e log no Worker
    if (event.reason?.name === 'ApiError') return;
    report(event.reason, String(event.reason));
  });
}
